import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { AddressModel, DeleteAddres } from 'src/app/models/address.model';
import { ModelLocatorService } from '../config/model-locator.service';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class UserAddressService {


    constructor(private httpService: HttpService,
        private modelLocator: ModelLocatorService) {

    }

    /**
     * Gets list of user address
     * @author Starley Cazorla
     * @returns
     */
    getListOfUserAddress() {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.GET_ADDRESSES, { "cpf": this.modelLocator.dadosLogin.cpf }, config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Saves user address
     * @author Starley Cazorla
     * @param body
     * @returns
     */
    saveUserAddress(body: AddressModel) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.ADD_ADDRESS, body, config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Updates user address
     * @author Starley Cazorla
     * @param body
     * @returns
     */
    updateUserAddress(body: AddressModel) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.UPDATE_ADDRESS, body, config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * Deletes user address
     * @author Starley Cazorla
     * @param body
     * @returns
     */
    deleteUserAddress(body: DeleteAddres) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(true);

            try {
                this.httpService.post(UrlConnectionEnum.DELETE_ADDRESS,  body , config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    }
                );
            } catch (error) {
                reject(error);
            }
        });
    }

}
